import { createSelector } from 'reselect';

export const siteWeatherConfigurationSelector = state => state.entities.siteWeatherConfigurations;

export const getWeatherConfigurationToSiteMapping = createSelector(siteWeatherConfigurationSelector, configurations =>
  configurations.mapKeys((key, value) => value.get('site') + ''),
);

export const selectSiteWeatherConfigurationById = createSelector(
  [siteWeatherConfigurationSelector, (state, id) => id],
  (configurations, id) => {
    const configuration = configurations.get(id + '');
    if (!configuration) {
      return null;
    }
    return configuration.toJS();
  },
);
